import { styled, Tooltip, tooltipClasses } from '@mui/material';

const LargeTooltip = styled(({ className, ...props }) => (
  <Tooltip arrow disableInteractive {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '1rem',
    padding: '10px 14px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    fontSize: '1.2rem',
  },
}));

export default LargeTooltip;